<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_1_' + this.id]">
    <div class="img">
      <div class="bulle">
        <div class="cadre">
          <h3>Léon</h3>
          <audio controls>
            <source src="https://cdn.exploreve.fr/content/voix/leon_installation_campement.mp3" type="audio/mpeg" />
          </audio>
          <p>
            Si tu ne peux pas écouter,<a
              class="next"
              target="_blank"
              href="https://cdn.exploreve.fr/content/transcriptions/leon_camp.pdf"
            >
              clique ici
            </a>
          </p>
        </div>
      </div>

      <div class="leon">
        <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="" />
      </div>
      <div class="support"></div>
    </div>

    <div>
      <NextButton class="button" :url="'/immersion01/' + (this.id + 1)" :text="'Installer mon campement'" />
    </div>

    <div class="nuage n01"></div>
    <div class="nuage n02"></div>
    <div class="nuage n03"></div>
    <div class="nuage n04"></div>
    <div class="nuage n05"></div>
    <div class="nuage n06"></div>
    <div class="nuage n07"></div>
    <div class="nuage n08"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import NextButton from "@/components/NextButton.vue";

export default {
  name: "IM_1_0",
  data: function () {
    return {
      id: 6
    };
  },
  components: {
    NextButton
  }
};
</script>

<style scoped lang="scss">
.container {
  text-align: left;
}

.title {
  margin-top: 100px;
}
.button {
  position: absolute;
  bottom: 6%;
  right: 13%;
  z-index: 20;
}
h3 {
  font-weight: 900;
}

p {
  font-size: 18px;
}

h1 {
  font-size: 36px;
  font-family: "Faune";
  margin-top: -30px;
}

.img {
  position: absolute;
  top: 10%;
  left: 10%;
  z-index: 5;
}

.bulle {
  position: absolute;
  top: 20px;
  left: 10%;
}

.next {
  color: $dark;
  text-align: right;
  text-decoration: underline;
  cursor: pointer;
}

.cadre {
  left: 370px;
  position: absolute;
  background-color: white;
  width: 350px;
  height: 200px;
  border-radius: 20px;
  text-align: left;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.cadre::after {
  content: "";
  position: absolute;
  left: -10%;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;

  border-right: 40px solid white;
}

.leon {
  position: absolute;
  top: 10%;
  left: 50px;
  img {
    height: 80vh;
  }
  z-index: 5;
}

.support {
  position: absolute;
  background-color: $light;
  left: 30px;
  top: 70vh;
  height: 15vh;
  width: 38vh;
  -webkit-border-radius: 19vh / 8vh;
  -moz-border-radius: 19vh / 8vh;
  border-radius: 19vh / 8vh;
}

.nuage {
  position: absolute;
  background-color: $light;
  opacity: 0.7;
}

.n01 {
  top: 10%;
  left: 40%;
  width: 619px;
  height: 121px;
  border-radius: 60px;
  z-index: 0;
}

.n02 {
  top: 30%;
  left: 80%;
  width: 197px;
  height: 33px;
  border-radius: 15px;
  z-index: 0;
}

.n03 {
  top: 35%;
  left: -5%;
  width: 641px;
  height: 145px;
  border-radius: 72px;
  z-index: 0;
}

.n04 {
  top: 35%;
  right: 0px;
  width: 317px;
  height: 62px;
  border-radius: 31px 0px 0px 31px;
  z-index: 0;
}

.n05 {
  top: 45%;
  left: 10%;
  width: 641px;
  height: 145px;
  border-radius: 72px;
  z-index: 0;
}

.n06 {
  top: 50%;
  left: 60%;
  width: 426px;
  height: 74px;
  border-radius: 72px;
  z-index: 0;
}

.n07 {
  top: 70%;
  left: 30%;
  width: 317px;
  height: 62px;
  border-radius: 31px;
  z-index: 10;
}

.n08 {
  top: 80%;
  left: -20%;
  width: 617px;
  height: 121px;
  border-radius: 60px;
  z-index: 5;
}
</style>
